import { ArrearsTableCard } from "./arrearsTable/ArrearsTableCard";
import { EmittedTitlesTableCard } from "./emittedTitlesTable/EmittedTitlesTableCard";
import React from "react";

export const ArrearsTabContent = ({ viewType = "arrears_documents" }: {
  viewType?: "arrears_documents" | "arrears_titles"
}) => {
  return viewType === "arrears_documents" ?
    <ArrearsTableCard /> :
    <EmittedTitlesTableCard />;
};